export default function getAccessToken() {
	if (window.ACCESS_TOKEN) {
		return window.ACCESS_TOKEN;
	}
	else if (window.App && window.App.oauth_accesstoken) {
		return window.App.oauth_accesstoken;
	}

	return null;
}



// WEBPACK FOOTER //
// ./src/shared/util/getAccessToken.js